import {
  DialogHeader,
  DialogFooter,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import axiosInstance from "@/utils/axiosInstance";
import React, { FC } from "react";
import { useRefresh } from "react-admin";
import { toast } from "sonner";

export const CompletionRequest = ({ id }: {id: number}) => {
  const refresh = useRefresh();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [status, setStatus] = React.useState("");

  const handleConfirm = (e: any, value: string) => {
    e.preventDefault();
    e.stopPropagation();
    setStatus(value);
    setOpenDialog(true);
  };

  const submit = async () => {
    if (!status) return;
    try {
      await axiosInstance.put(
        `/taxi-orders/${id}`,
        {
          status,
        },
      );

      toast(`Order completed successfully`, {
        className: "absolute bottom-10 right-10 z-50",
      });

      refresh();
    } catch (err) {
      console.error("Failed to update order status", err);
      toast("Something went wrong", {
        className: "absolute bottom-10 right-10 z-50 text-red-500",
      });
    } finally {
      setOpenDialog(false);
    }
  };

  return (
    <>
      <Button
        variant="default"
        size="sm"
        onClick={(e) => handleConfirm(e, "COMPLETED")}
      >
        Confirm Order
      </Button>

      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirm</DialogTitle>
            <DialogDescription>
              Do you want to complete this order?
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenDialog(false);
              }}
            >
              No
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                submit();
              }}
            >
              Yes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CompletionRequest;
